import httpClient from './httpClient';

const API_BASE = '/api/bar-stock';

export const barStockService = {
  async calculateRequirements(data) {
    const response = await httpClient.post(`${API_BASE}/calculate`, data);
    return response.data;
  },

  async generateCutPlan(data) {
    const response = await httpClient.post(`${API_BASE}/cut-plan/generate`, data);
    return response.data;
  },

  async getBarStockMaterials(tipDiameter, minLength = 200) {
    const response = await httpClient.get(`${API_BASE}/materials`, {
      params: { tip_diameter: tipDiameter, min_length: minLength }
    });
    return response.data;
  },

  // Search across ALL active bar stock materials (no tip_diameter/min_length
  // constraint) - used by leftover registration where the actual bar may not
  // match the work order's BOM.
  async searchBarStockMaterials(search = '') {
    const response = await httpClient.get(`${API_BASE}/materials`, {
      params: { search }
    });
    return response.data;
  },

  async getRemainingBars(tipDiameter, minLength = 50) {
    const response = await httpClient.get(`${API_BASE}/remaining`, {
      params: { tip_diameter: tipDiameter, min_length: minLength }
    });
    return response.data;
  },

  async handleWorkOrderCompletion(data) {
    const response = await httpClient.post(`${API_BASE}/work-order/complete`, data);
    return response.data;
  },

  async saveCutPlan(data) {
    const response = await httpClient.post(`${API_BASE}/cut-plan/save`, data);
    return response.data;
  }
};

export default barStockService;
